module.exports = __webpack_public_path__ + "media/img/favicon/safari-pinned-tab-f72a60adddaaafa1fc65ba50116b5f33.svg";